import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class AttendanceLoader extends Loader {}

export const attendanceLoader = new AttendanceLoader({
  service: SERVICES.attendance,
})
